import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setInfo, setSuccess, setWarning } from "../common/toast/toast";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { bandeiras } from "../assets/icons";

export function setFiltro(filtro) {
    return {
        type: "ANALISE_SET_FILTRO",
        payload: filtro,
    };
}

export function setAguardando(aguardando) {
    return {
        type: "ANALISE_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function setTabSelecionada(tab) {
    return {
        type: "ANALISE_TAB_SELECIONADA",
        payload: tab,
    };
}

// export function setAbas(abas) {
//     return {
//         type: "ANALISE_ABAS_CARREGADA",
//         payload: abas,
//     };
// }

export async function getListaAnosEmpenho() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));

            const filtroIdCliente = getState().analise.filtro.id_cliente;

            //se não tiver filtro de cliente não retorna nada
            if (!filtroIdCliente) {
                return {
                    type: "ANALISE_TABELA_GESTAO_EMPENHO_LISTA_ANOS",
                    payload: { data: [] },
                };
            }

            const url = `${consts.API_URL}/empenho/anos?id_usuario_logado=${usuarioLogado.id}&id_cliente=${filtroIdCliente}`;
            const resposta = await axios.get(url);
            dispatch({
                type: "ANALISE_TABELA_GESTAO_EMPENHO_LISTA_ANOS",
                payload: resposta,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function getListaEmpenho() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));

            const filtroIdCliente = getState().analise.filtro.id_cliente;
            const filtroAno = getState().analise.filtro.ano_referencia;

            //se não tiver filtro de cliente não retorna nada
            if (!filtroIdCliente) {
                return {
                    type: "ANALISE_TABELA_GESTAO_EMPENHO_LISTADO",
                    payload: { data: [] },
                };
            }

            const url = `${consts.API_URL}/analise-empenho?id_usuario_logado=${usuarioLogado.id}&id_cliente=${filtroIdCliente}&ano_referencia=${filtroAno}`;
            const resposta = await axios.get(url);
            dispatch({
                type: "ANALISE_TABELA_GESTAO_EMPENHO_LISTADO",
                payload: resposta,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function getDemandaContagem() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_DEMANDA_CONTAGEM_LISTADO",
                payload: { data: [] },
            });

            dispatch({
                type: "ANALISE_AGENDAMENTO_DEMANDA",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || 0;
            const idTipoContratoDemanda = state.filtro.id_tipo_contrato_demanda || 0;
            const resp = await axios.get(
                `${consts.API_URL}/demandaContrato/listarContagemComAgendamentoDemanda?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
            );

            if (state.filtro.unidades_consumidoras.length == 1) {
                const idUcSelecionada = state.filtro.unidades_consumidoras[0].value;
                const demanda = resp.data.find((demanda) => demanda.id_unidade_consumidora == idUcSelecionada) || {};
                const idTipoContratoDemanda = state.filtro.id_tipo_contrato_demanda || 0;
                const listaAgendamentoDemanda = await getListaAgendamento(demanda.id, idTipoContratoDemanda);
                listaAgendamentoDemanda.forEach((agendamento, indice, lista) => {
                    const ano = String(agendamento.competencia_inicio_vigencia).substring(0, 4);
                    const mes = String(agendamento.competencia_inicio_vigencia).substring(4, 6);

                    const agendamentoOrdenado = {};

                    //ordernar conforme mes de inicio, para que inicie em janeiro na tabela
                    for (let i = demanda.mes_inicio, j = 1; j <= 12; j++, i++) {
                        if (i > 12) {
                            i = 1;
                        }
                        agendamentoOrdenado[`valor_${i}`] = agendamento[`valor_${j}`];
                    }
                    agendamentoOrdenado.id_demanda_contrato = demanda.id;
                    agendamentoOrdenado.competencia_inicio_vigencia = agendamento.competencia_inicio_vigencia;
                    agendamentoOrdenado.competencia_formatada = `Agendado ${mes}/${ano}`;
                    agendamentoOrdenado.mensagem_tooltip = `Início previsto para ${mes}/${ano}`;

                    lista[indice] = { ...agendamentoOrdenado };
                });
                listaAgendamentoDemanda.sort((a, b) => a.competencia_inicio_vigencia - b.competencia_inicio_vigencia);

                dispatch({
                    type: "ANALISE_AGENDAMENTO_DEMANDA",
                    payload: { data: listaAgendamentoDemanda },
                });
            }

            dispatch({
                type: "ANALISE_DEMANDA_CONTAGEM_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

async function getListaAgendamento(idDemanda, idTipoContratoDemanda) {
    try {
        const agendamentos = await axios.get(
            `${consts.API_URL}/demandaAgendamento?id_demanda_contrato=${idDemanda || 0}&id_tipo_contrato_demanda=${idTipoContratoDemanda}&executado=false`
        );
        return agendamentos.data || [];
    } catch (erro) {
        setErroAPI(erro);
        return [];
    }
}

export function excluirPeriodoTeste(registro) {
    return (dispatch, getState) => {
        if (window.confirm(`Deseja realmente excluir o período de teste?`)) {
            axios
                .delete(`${consts.API_URL}/demandaContrato/periodoTeste/?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getDemandaContagem());
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        }
    };
}

export function excluirAgendamento(registro) {
    return (dispatch, getState) => {
        if (window.confirm(`Deseja realmente excluir o agendamento de ${registro.competencia_agendamento}?`)) {
            axios
                .delete(`${consts.API_URL}/demandaAgendamento?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getDemandaContagem());
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        }
    };
}

function filtrarIdsUnidadesConsumidoras(state) {
    const filtroGrupoFaturamento = state.filtro.grupos_faturamento.map((item) => parseInt(item.value)); //apenas os ids do filtro
    //se selecionou alguma UC manda a lista de ids das UCs selecionadas
    let ids_unidades_consumidoras = state.filtro.unidades_consumidoras.map((item) => item.value);
    if (ids_unidades_consumidoras.length) {
        return ids_unidades_consumidoras;
    }
    //se não tiver nenhuma UC selecionada, filtra a lista de UC original de acordo com os filtros selecionados
    const listaUCs = state.listaUnidadeConsumidora
        .filter(
            (item) =>
                (!state.filtro.id_cliente || item.id_cliente == state.filtro.id_cliente) &&
                (state.tabSelecionada === "demanda"
                    ? [1, 4].includes(parseInt(item.id_grupo_faturamento)) || (item.id_grupo_faturamento === 3 && item.irrigante)
                    : (!filtroGrupoFaturamento.length || filtroGrupoFaturamento.includes(item.id_grupo_faturamento)) &&
                      ((state.filtro.irrigante && item.irrigante) || (state.filtro.naoIrrigante && !item.irrigante)))
        )
        .map((item) => item.id);

    //se após filtrar as UCs a lista acabar vazia, significa que nenhuma UC se enquadra no filtro
    //entao adiciona retorna uma lista contendo o id 0, que é inválido, para que não traga nenhuma informação
    return listaUCs.length ? listaUCs : [0];
}

export async function getListaGraficoValorDevolvidoAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_DEVOLUCAO_ANUAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const modoSafra = state.filtro.devolucao_ano_safra;

            //se for tipo safra os meses iniciam em junho no gráfico
            const endpoint = modoSafra ? "listarGraficoValorDevolvidoSafra" : "listarGraficoValorDevolvidoAnual";

            //valida o id do cliente
            const id_cliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/${endpoint}?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&ids_unidades_consumidoras=${encodeURIComponent(
                    ids_unidades_consumidoras
                )}&id_empresa=${idEmpresa}`
            );

            //se o ano/safra atual do filtro não existe na lista do novo cliente altera o ano/safra para o último período da lista
            const anosSelect = resp.data.map((item) => (modoSafra ? item.ano_inicio_fim_safra.split("/")[0] : item.ano));
            if (!anosSelect.find((item) => item == state.filtro.ano_devolucao)) {
                let anoFiltro = anosSelect.length ? anosSelect[anosSelect.length - 1] : new Date().getFullYear();
                dispatch(
                    setFiltro({
                        ...state.filtro,
                        ano_devolucao: anoFiltro,
                        competencia_inicial_comparativo_devolucao_ressarcimento: modoSafra ? `${anoFiltro}06` : `${anoFiltro}01`,
                        competencia_final_comparativo_devolucao_ressarcimento: modoSafra ? `${parseInt(anoFiltro) + 1}05` : `${anoFiltro}12`,
                        competencia_inicial_devolucao_por_uc: modoSafra ? `${anoFiltro}06` : `${anoFiltro}01`,
                        competencia_final_devolucao_por_uc: modoSafra ? `${parseInt(anoFiltro) + 1}05` : `${anoFiltro}12`,
                    })
                );
            }
            dispatch({
                type: "ANALISE_GRAFICO_DEVOLUCAO_ANUAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoCustoMensalUsinaAluguel() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const state = getState().analise;

            //se for tipo safra os meses iniciam em junho no gráfico

            //valida o id do cliente
            const id_cliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_contrato_aluguel_historico = state.filtro.ids_contrato_aluguel_historico;
            const id_unidade_remota_contrato_aluguel = state.filtro.id_unidade_remota_contrato_aluguel;
            if (!id_cliente || !ids_contrato_aluguel_historico.length) {
                return {};
            }

            dispatch({
                type: "ANALISE_GRAFICO_ALUGUEL_USINA_MENSAL_LISTADO",
                payload: { data: [] },
            });
            dispatch(setAguardando(true));
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoMensalUsinaAluguel?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&ids_contrato_aluguel_historico=${encodeURIComponent(ids_contrato_aluguel_historico)}&id_unidade_remota_contrato_aluguel=${id_unidade_remota_contrato_aluguel}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_ALUGUEL_USINA_MENSAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
export async function getListaEconomiaUsinaAluguelRemotasMensal() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const state = getState().analise;

            //se for tipo safra os meses iniciam em junho no gráfico

            //valida o id do cliente
            const id_cliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_contrato_aluguel_historico = state.filtro.ids_contrato_aluguel_historico;
            const id_unidade_remota_contrato_aluguel = state.filtro.id_unidade_remota_contrato_aluguel;
            if (!id_cliente) {
                return {};
            }
            if (id_cliente && !ids_contrato_aluguel_historico.length) {
                return {};
            }

            dispatch({
                type: "ANALISE_ECONOMIA_REMOTAS_USINA_ALUGUEL_MENSAL_LISTADO",
                payload: { data: [] },
            });
            dispatch(setAguardando(true));
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarEconomiaUsinaAluguelRemotasMensal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${
                    id_cliente
                }&ids_contrato_aluguel_historico=${encodeURIComponent(ids_contrato_aluguel_historico)}&id_unidade_remota_contrato_aluguel=${id_unidade_remota_contrato_aluguel}`
            );
            dispatch({
                type: "ANALISE_ECONOMIA_REMOTAS_USINA_ALUGUEL_MENSAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function getListaGraficoValorDevolvidoMensalAno() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_DEVOLUCAO_MENSAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            //se for tipo safra os meses iniciam em junho no gráfico
            const endpoint = state.filtro.devolucao_ano_safra ? "listarGraficoValorDevolvidoMensalSafra" : "listarGraficoValorDevolvidoMensalAno";

            //valida o id do cliente
            const id_cliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/${endpoint}?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&ids_unidades_consumidoras=${encodeURIComponent(
                    ids_unidades_consumidoras
                )}&ano=${state.filtro.ano_devolucao}&id_empresa=${idEmpresa}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_DEVOLUCAO_MENSAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoValorDevolvidoRessarcidoPeriodo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_DEVOLUCAO_RESSARCIMENTO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;

            //valida o id do cliente
            const id_cliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoValorDevolvidoRessarcidoPeriodo?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${id_cliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&competencia_inicial=${
                    state.filtro.competencia_inicial_comparativo_devolucao_ressarcimento
                }&competencia_final=${state.filtro.competencia_final_comparativo_devolucao_ressarcimento}&id_empresa=${idEmpresa}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_DEVOLUCAO_RESSARCIMENTO_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoValorDevolvidoPorUC() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_DEVOLUCAO_POR_UC_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;

            //valida o id do cliente
            const id_cliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoValorDevolvidoPorUC?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${id_cliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&competencia_inicial=${
                    state.filtro.competencia_inicial_devolucao_por_uc
                }&competencia_final=${state.filtro.competencia_final_devolucao_por_uc}&id_empresa=${idEmpresa}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_DEVOLUCAO_POR_UC_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListarGraficoCustoJurosPorAtrasoPagamentoAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_JUROS_POR_ATRASO_PAGAMENTO_ANUAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const modoSafra = state.filtro.custo_ano_safra;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoJurosPorAtrasoPagamentoAnual?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}&periodo_safra=${modoSafra}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_JUROS_POR_ATRASO_PAGAMENTO_ANUAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListarGraficoCustoJurosPorAtrasoPagamentoMensal() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_JUROS_POR_ATRASO_PAGAMENTO_MENSAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;

            const modoSafra = state.filtro.custo_ano_safra;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoJurosPorAtrasoPagamentoMensal?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}&periodo_safra=${modoSafra}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_JUROS_POR_ATRASO_PAGAMENTO_MENSAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoCustoAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_ANUAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const modoSafra = state.filtro.custo_ano_safra;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCusto?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(
                    idsUnidadesConsumidoras
                )}&periodo_safra=${modoSafra}`
            );

            let anosSelect = [];
            resp.data.forEach((item) => {
                item.anos.forEach((ano, i, array) => {
                    const objAno = modoSafra ? { ...ano, ano: String(ano.ano).replace("-", "/") } : ano;
                    array[i] = objAno;
                    const anoFormatado = String(objAno.ano).includes("/") ? String(objAno.ano).split("/")[0] : String(objAno.ano);
                    if (!anosSelect.find((itemAno) => itemAno == anoFormatado)) {
                        anosSelect.push(anoFormatado);
                    }
                });
            });
            //ordena a lista de anos
            anosSelect.sort((a, b) => {
                return modoSafra ? a.split("/")[0] - b.split("/")[0] : a - b;
            });
            if (!anosSelect.find((item) => item == state.filtro.ano_custo)) {
                let anoFiltro = anosSelect.length ? anosSelect[anosSelect.length - 1] : new Date().getFullYear();
                let mesAtual = new Date().getMonth() + 1;
                mesAtual = mesAtual < 10 ? "0" + mesAtual : mesAtual;
                dispatch(
                    setFiltro({
                        ...state.filtro,
                        ano_custo: anoFiltro,
                        custo_ano_safra: modoSafra,
                        competencia_inicial_custo: modoSafra ? `${anoFiltro}06` : `${anoFiltro}01`,
                        competencia_final_custo: modoSafra ? `${parseInt(anoFiltro) + 1}05` : `${anoFiltro}12`,
                        competencia_inicial_unidade_custo: modoSafra ? `${anoFiltro}06` : `${anoFiltro}01`,
                        competencia_final_unidade_custo: modoSafra ? `${parseInt(anoFiltro) + 1}05` : `${anoFiltro}12`,
                        competencia_inicial_custo_comparativo_antes: modoSafra ? `${parseInt(anoFiltro) - 1}06` : `${parseInt(anoFiltro) - 1}01`,
                        competencia_final_custo_comparativo_antes: modoSafra ? `${anoFiltro}05` : `${parseInt(anoFiltro) - 1}${mesAtual}`,
                        competencia_inicial_custo_comparativo_depois: modoSafra ? `${anoFiltro}06` : `${anoFiltro}01`,
                        competencia_final_custo_comparativo_depois: modoSafra ? `${parseInt(anoFiltro) + 1}05` : `${anoFiltro}${mesAtual}`,
                        ano_acumulado_custo: anoFiltro,
                    })
                );
            }

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_ANUAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoTarifaMedia() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_TARIFA_MEDIA_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const modoSafra = state.filtro.tarifa_ano_safra;
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoTarifaMedia?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
			&periodo_safra=${modoSafra}`
            );
            if (modoSafra) {
                resp.data.forEach((item) => {
                    item.anos = item.anos.map((ano) => ({ ...ano, ano: String(ano.ano).replace("-", "/") }));
                });
            }
            dispatch({
                type: "ANALISE_GRAFICO_TARIFA_MEDIA_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoTarifaTeTusdMensal() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_TARIFA_TE_TUSD_MENSAL_LISTADO",
                payload: { data: Array.from({ length: 12 }, () => ({ media_te: 0, media_tusd: 0 })) },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const modoSafra = state.filtro.tarifa_ano_safra;

            if (idsUnidadesConsumidoras.length != 1) return {};

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoTarifaTeTusdMensal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&horario=${
                    state.filtro.horario_tarifa
                }&ano=${state.filtro.ano_tarifa}&periodo_safra=${modoSafra}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_TARIFA_TE_TUSD_MENSAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoTarifaMediaGeral() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_TARIFA_MEDIA_GERAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const modoSafra = state.filtro.tarifa_ano_safra;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoTarifaMedia?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
			&geral=true
			&periodo_safra=${modoSafra}`
            );
            if (modoSafra) {
                resp.data.forEach((item) => {
                    item.anos = item.anos.map((ano) => ({ ...ano, ano: String(ano.ano).replace("-", "/") }));
                });
            }
            dispatch({
                type: "ANALISE_GRAFICO_TARIFA_MEDIA_GERAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoCustoPorHorarioAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_HORARIO_ANUAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoPorHorario?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
			&ano=${state.filtro.anoComparativoPizza || state.filtro.ano}
			&competencia_inicial=${state.filtro.competencia_inicial_horario}
			&competencia_final=${state.filtro.competencia_final_horario}`
            );
            const unidadeConsumidora = state.listaUnidadeConsumidora.find((item) => state.filtro.unidades_consumidoras.find((uc) => uc.value == item.id));

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_HORARIO_ANUAL_LISTADO",
                payload: {
                    data: resp.data.map((item) => ({
                        mes: item.mes,
                        tipos: item.tipos.filter((tipo) => {
                            if (tipo.tipo == "Reservado") {
                                return !unidadeConsumidora || unidadeConsumidora.id_grupo_faturamento == 2 || unidadeConsumidora.irrigante;
                            } else {
                                return true;
                            }
                        }),
                    })),
                },
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoConsumoPorHorarioAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_HORARIO_ANUAL_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoConsumoPorHorario?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
			&competencia_inicial=${state.filtro.competencia_inicial_horario}
			&competencia_final=${state.filtro.competencia_final_horario}`
            );
            const unidadeConsumidora = state.listaUnidadeConsumidora.find((item) => state.filtro.unidades_consumidoras.find((uc) => uc.value == item.id));

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_HORARIO_ANUAL_LISTADO",
                payload: {
                    data: resp.data.map((item) => ({
                        mes: item.mes,
                        tipos: item.tipos.filter((tipo) => {
                            if (tipo.tipo == "Reservado") {
                                return !unidadeConsumidora || unidadeConsumidora.id_grupo_faturamento == 2 || unidadeConsumidora.irrigante;
                            } else {
                                return true;
                            }
                        }),
                    })),
                },
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoCustoDemandaEnergiaConsumida() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_DEMANDA_ENERGIA_CONSUMIDA_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoDemandaEnergiaConsumida?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}&ano=${
                    state.filtro.anoComparativoPizza || state.filtro.ano
                }&competencia_inicial=${state.filtro.competencia_inicial_horario}&competencia_final=${state.filtro.competencia_final_horario}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_DEMANDA_ENERGIA_CONSUMIDA_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoConsumoPorHorarioMensal() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_HORARIO_MENSAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoConsumoPorHorario?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
			&ano=${state.filtro.anoComparativoPizza || state.filtro.ano}
			&competencia_inicial=${state.filtro.competencia_inicial_horario}
			&competencia_final=${state.filtro.competencia_final_horario}
            &periodo_safra=${state.filtro.horario_ano_safra}`
            );
            const unidadeConsumidora = state.listaUnidadeConsumidora.find((item) => state.filtro.unidades_consumidoras.find((uc) => uc.value == item.id));

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_HORARIO_MENSAL_LISTADO",
                payload: {
                    data: resp.data.map((item) => ({
                        mes: item.mes,
                        tipos: item.tipos.filter((tipo) => {
                            if (tipo.tipo == "Reservado") {
                                return !unidadeConsumidora || unidadeConsumidora.id_grupo_faturamento == 2 || unidadeConsumidora.irrigante;
                            } else {
                                return true;
                            }
                        }),
                    })),
                },
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}
export async function getListaGraficoConsumoPonta() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_PONTA_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoConsumoPonta?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
            &periodo_safra=${state.filtro.horario_ano_safra}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_PONTA_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoConsumoForaPonta() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_FORA_PONTA_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoConsumoForaPonta?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
			&periodo_safra=${state.filtro.horario_ano_safra}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_FORA_PONTA_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}
export async function getListaGraficoConsumoReservado() {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        try {
            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_RESERVADO_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoConsumoReservado?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
			&periodo_safra=${state.filtro.horario_ano_safra}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_RESERVADO_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getDemanda() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_DEMANDA_LISTADO",
                payload: null,
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/demandaContrato?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_tipo_contrato_demanda=${
                    state.filtro.id_tipo_contrato_demanda
                }&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&encerrado=false`
            );
            const demandas = resp.data || [];
            //só seta a vigente quando seleciona uma única UC no filtro
            let vigente = null;
            if (state.filtro.unidades_consumidoras.length == 1) {
                const idUcSelecionada = state.filtro.unidades_consumidoras[0].value;
                vigente = resp.data.find((demanda) => demanda.id_unidade_consumidora == idUcSelecionada) || null;
            }
            dispatch({
                type: "ANALISE_DEMANDA_LISTADO",
                payload: {
                    demandas,
                    vigente,
                },
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoDemanda(lista) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_DEMANDA_LISTADO",
                payload: { data: lista || [] },
            });
            dispatch({
                type: "ANALISE_GRAFICO_DEMANDA_INDICE_SAZONALIDADE_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            if (!lista && idCliente) {
                let respostaListaGrafico = { data: [] };
                let respostaIdicesSazonalidade = { data: [] };

                const idTipoContratoDemanda = state.filtro.id_tipo_contrato_demanda || 0;
                const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

                //sazonal e não sazonal apenas quando tiver uma Única UC
                if ((ids_unidades_consumidoras || []).length == 1) {
                    const ucSelecionada = state.listaUnidadeConsumidora.find((uc) => uc.id == ids_unidades_consumidoras[0]);
                    const idUnidadeConsumidora = ucSelecionada.id;
                    //SE FOR UMA UC APENAS, TRAZ DADOS SAZONAL OU NÂO SAZONAL, DE ACORDO COM A UC
                    if (ucSelecionada.contrato_demanda_sazonal) {
                        respostaIdicesSazonalidade = await axios.get(
                            `${consts.API_URL}/fatura/listarSazonalidadeAnualPorUcSazonal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_unidade_consumidora=${idUnidadeConsumidora}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                        );

                        //busca enpoint sazonal *fazer rota
                        respostaListaGrafico = await axios.get(
                            `${consts.API_URL}/fatura/listarGraficoDemandaSazonal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_unidade_consumidora=${idUnidadeConsumidora}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                        );
                    } else {
                        respostaIdicesSazonalidade = await axios.get(
                            `${consts.API_URL}/fatura/listarSazonalidadeAnualPorUcNaoSazonal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_unidade_consumidora=${idUnidadeConsumidora}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                        );

                        //busca enpoint nao sazonal *fazer rota
                        respostaListaGrafico = await axios.get(
                            `${consts.API_URL}/fatura/listarGraficoDemandaNaoSazonal?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&id_unidade_consumidora=${idUnidadeConsumidora}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                        );
                    }
                } else {
                    //se não tiver UC no filtro, ou tiver mais de uma, traz totalizadores apenas
                    respostaListaGrafico = await axios.get(
                        `${consts.API_URL}/fatura/listarGraficoDemandaNovo?id_usuario_logado=${
                            usuarioLogado.id
                        }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&id_tipo_contrato_demanda=${idTipoContratoDemanda}`
                    );
                }
                dispatch({
                    type: "ANALISE_GRAFICO_DEMANDA_INDICE_SAZONALIDADE_LISTADO",
                    payload: respostaIdicesSazonalidade,
                });
                dispatch({
                    type: "ANALISE_GRAFICO_DEMANDA_LISTADO",
                    payload: respostaListaGrafico,
                });
            }
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoConsumoAnual(lista) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_ANUAL_LISTADO",
                payload: { data: lista || [] },
            });

            const state = getState().analise;
            const modoSafra = state.filtro.consumo_ano_safra;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            if (!lista && idCliente) {
                const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);
                //sazonal e não sazonal apenas quando tiver uma Única UC

                const resp = await axios.get(
                    `${consts.API_URL}/fatura/listarGraficoConsumoFaturaComInstantaneo?id_usuario_logado=${
                        usuarioLogado.id
                    }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&periodo_safra=${modoSafra}`
                );

                let anosSelect = [];
                resp.data.forEach((item) => {
                    item.anos.forEach((ano, i, array) => {
                        const objAno = modoSafra ? { ...ano, ano: String(ano.ano).replace("-", "/") } : ano;
                        array[i] = objAno;
                        const anoFormatado = String(objAno.ano).includes("/") ? String(objAno.ano).split("/")[0] : String(objAno.ano);
                        if (!anosSelect.find((itemAno) => itemAno == anoFormatado)) {
                            anosSelect.push(anoFormatado);
                        }
                    });
                });
                //ordena a lista de anos
                anosSelect.sort((a, b) => {
                    return modoSafra ? a.split("/")[0] - b.split("/")[0] : a - b;
                });
                if (!anosSelect.find((item) => item == state.filtro.ano_consumo)) {
                    let anoFiltro = anosSelect.length ? anosSelect[anosSelect.length - 1] : new Date().getFullYear();
                    let mesAtual = new Date().getMonth() + 1;
                    mesAtual = mesAtual < 10 ? "0" + mesAtual : mesAtual;
                    dispatch(
                        setFiltro({
                            ...state.filtro,
                            ano_consumo: anoFiltro,
                            consumo_ano_safra: modoSafra,
                            competencia_inicial_consumo_comparativo_antes: modoSafra ? `${parseInt(anoFiltro) - 1}06` : `${parseInt(anoFiltro) - 1}01`,
                            competencia_final_consumo_comparativo_antes: modoSafra ? `${anoFiltro}05` : `${parseInt(anoFiltro) - 1}${mesAtual}`,
                            competencia_inicial_consumo_comparativo_depois: modoSafra ? `${anoFiltro}06` : `${anoFiltro}01`,
                            competencia_final_consumo_comparativo_depois: modoSafra ? `${parseInt(anoFiltro) + 1}05` : `${anoFiltro}${mesAtual}`,
                            ano_acumulado_consumo: anoFiltro,
                        })
                    );
                }

                dispatch({
                    type: "ANALISE_GRAFICO_CONSUMO_ANUAL_LISTADO",
                    payload: resp,
                });
            }
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

//primeiro grafico aba reativo
export async function getListaGraficoCustoReativoAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_LISTADO_ANUAL",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const modoSafra = state.filtro.reativo_ano_safra;

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoReativoAnual?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&periodo_safra=${modoSafra}&id_empresa=${idEmpresa}`
            );

            //se o ano/safra atual do filtro não existe na lista do novo cliente altera o ano/safra para o último período da lista
            const anosSelect = resp.data.map((item) => (modoSafra ? item.ano_inicio_fim_safra.split("/")[0] : item.ano));
            if (!anosSelect.find((item) => item == state.filtro.ano_reativo)) {
                let anoFiltro = anosSelect.length ? anosSelect[anosSelect.length - 1] : new Date().getFullYear();
                dispatch(
                    setFiltro({
                        ...state.filtro,
                        ano_reativo: anoFiltro,
                        competencia_inicial_reativo: modoSafra ? `${anoFiltro}06` : `${anoFiltro}01`,
                        competencia_final_reativo: modoSafra ? `${parseInt(anoFiltro) + 1}05` : `${anoFiltro}12`,
                    })
                );
            }

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_LISTADO_ANUAL",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

//segundo grafico aba reativo
export async function getListaGraficoCustoReativoMensal() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_LISTADO_MENSAL",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const modoSafra = state.filtro.reativo_ano_safra;

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoReativoMensal?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&periodo_safra=${modoSafra}&id_empresa=${idEmpresa}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_LISTADO_MENSAL",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

//terceiro grafico aba reativo
export async function getListaGraficoConsumoReativoMensal() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_REATIVO_LISTADO_MENSAL",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const modoSafra = state.filtro.reativo_ano_safra;

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoConsumoReativoMensal?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&periodo_safra=${modoSafra}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_REATIVO_LISTADO_MENSAL",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoCustoReativoPorUnidadeAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_UNIDADE_ANUAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoReativoPorUnidade?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&competencia_inicial=${
                    state.filtro.competencia_inicial_reativo
                }&competencia_final=${state.filtro.competencia_final_reativo}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_UNIDADE_ANUAL_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoCustoReativoTipo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_TIPO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoReativoTipos?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&competencia_inicial=${
                    state.filtro.competencia_inicial_reativo
                }&competencia_final=${state.filtro.competencia_final_reativo}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_TIPO_LISTADO",
                payload: {
                    data: resp.data.map((item) => ({
                        ...item,
                        tipos: item.anos,
                    })),
                },
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoCustoMultaAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_MULTA_ANUAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);
            const modoSafra = state.filtro.multas_ano_safra;

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoMulta?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(
                    ids_unidades_consumidoras
                )}&periodo_safra=${modoSafra}&id_empresa=${idEmpresa}`
            );
            //se o ano/safra atual do filtro não existe na lista do novo cliente altera o ano/safra para o último período da lista
            const anosSelect = resp.data.map((item) => (modoSafra ? item.ano_inicio_fim_safra.split("/")[0] : item.ano));
            if (!anosSelect.find((item) => item == state.filtro.ano_multas)) {
                let anoFiltro = anosSelect.length ? anosSelect[anosSelect.length - 1] : new Date().getFullYear();
                dispatch(
                    setFiltro({
                        ...state.filtro,
                        ano_multas: anoFiltro,
                        competencia_inicial_comparativo_tipo_multa: modoSafra ? `${anoFiltro}06` : `${anoFiltro}01`,
                        competencia_final_comparativo_tipo_multa: modoSafra ? `${parseInt(anoFiltro) + 1}05` : `${anoFiltro}12`,
                    })
                );
            }
            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_MULTA_ANUAL_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoCustoMultaAgrupado() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_MULTA_AGRUPADO_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoTiposMulta?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}
			&competencia_inicial=${state.filtro.competencia_inicial_comparativo_tipo_multa}
			&competencia_final=${state.filtro.competencia_final_comparativo_tipo_multa}&id_empresa=${idEmpresa}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_MULTA_AGRUPADO_LISTADO",
                payload: {
                    data: resp.data.map((item) => ({
                        ...item,
                        tipos: item.anos,
                    })),
                },
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoCustoReativoTipoMulta() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_TIPO_MULTA_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoReativoTipos?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}
			&competencia_inicial=${state.filtro.competencia_inicial_comparativo_tipo_multa}
			&competencia_final=${state.filtro.competencia_final_comparativo_tipo_multa}&id_empresa=${idEmpresa}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_TIPO_MULTA_LISTADO",
                payload: {
                    data: resp.data.map((item) => ({
                        ...item,
                        tipos: item.anos,
                    })),
                },
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoGeracaoAvaliacaoProducao() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_AVALIACAO_PRODUCAO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoAvaliacaoProducao?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_AVALIACAO_PRODUCAO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoGeracaoQuantidadeAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_QUANTIDADE_ANUAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoQuantidade?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_QUANTIDADE_ANUAL_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoGeracaoSaldo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_SALDO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoSaldo?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_SALDO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaIndiceAntesDepois() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GERACAO_INDICE_ANTES_DEPOIS_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : getState().analise.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarIndicesAntesDepois?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}`
            );
            dispatch({
                type: "ANALISE_GERACAO_INDICE_ANTES_DEPOIS_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoGeracaoComparativoConsumo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_COMPARATIVO_CONSUMO_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoComparativoConsumo?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_COMPARATIVO_CONSUMO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGeracaoComparativoConsumo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_TABELA_CONSUMO_HORARIO_COMPARATIVO_PERIODO_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || 0;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarTabelaConsumoHorarioComparativoPeriodo?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}&competencia_inicial_horario_comparativo_antes=${
                    state.filtro.competencia_inicial_horario_comparativo_antes || null
                }&competencia_final_horario_comparativo_antes=${state.filtro.competencia_final_horario_comparativo_antes || null}&competencia_inicial_horario_comparativo_depois=${
                    state.filtro.competencia_inicial_horario_comparativo_depois || null
                }&competencia_final_horario_comparativo_depois=${state.filtro.competencia_final_horario_comparativo_depois || null}`
            );
            dispatch({
                type: "ANALISE_TABELA_CONSUMO_HORARIO_COMPARATIVO_PERIODO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoGeracaoConsumoInstantaneo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_CONSUMO_INSTANTANEO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoConsumoInstantaneo?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_CONSUMO_INSTANTANEO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoGeracaoEconomia() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_ECONOMIA_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoEconomia?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_ECONOMIA_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoConsumoPorUnidadeAcumuladoAno() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_UNIDADE_ACUMULADO_ANO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const modoSafra = state.filtro.consumo_ano_safra;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || 0;
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoConsumoPorUnidadeAcumuladoAno?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}&periodo_safra=${modoSafra}${
                    modoSafra
                        ? `&competencia_inicial=${state.filtro.ano_acumulado_consumo}06&competencia_final=${parseInt(state.filtro.ano_acumulado_consumo) + 1}05`
                        : `&competencia_base=${state.filtro.ano_acumulado_consumo}12`
                }`
            );

            dispatch({
                type: "ANALISE_GRAFICO_CONSUMO_UNIDADE_ACUMULADO_ANO_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoCustoPorUnidadeAcumuladoAno() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_UNIDADE_ACUMULADO_ANO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const modoSafra = state.filtro.custo_ano_safra;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || 0;
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoPorUnidadeAcumuladoAno?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}&periodo_safra=${modoSafra}${
                    modoSafra
                        ? `&competencia_inicial=${state.filtro.ano_acumulado_custo}06&competencia_final=${parseInt(state.filtro.ano_acumulado_custo) + 1}05`
                        : `&competencia_base=${state.filtro.ano_acumulado_custo}12`
                }`
            );

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_UNIDADE_ACUMULADO_ANO_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            console.log(ex);
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoCustoPorUnidadeAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_UNIDADE_ANUAL_LISTADO",
                payload: { data: [] },
            });
            const state = getState();
            const modoSafra = state.analise.filtro.custo_ano_safra;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.analise.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoPorUnidadeGrupo?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&periodo_safra=${modoSafra}&competencia_inicial=${state.analise.filtro.competencia_inicial_unidade_custo}&competencia_final=${state.analise.filtro.competencia_final_unidade_custo}`
            );

            //modifica ano de 2023-2024 para 2023/2024
            resp.data = (resp.data || []).map((item) => {
                const anos = (item.anos || []).map((obj) => ({ ...obj, ano: String(obj.ano).replace("-", "/") }));
                return { ...item, anos };
            });

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_UNIDADE_ANUAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaCustoPorUnidadePeriodo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_CUSTO_POR_UNIDADE_PERIODO_LISTADO",
                payload: { data: [] },
            });
            const state = getState().analise;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarCustoPorUnidadePeriodo?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(
                    idsUnidadesConsumidoras
                )}
				&competencia_inicial_antes=${state.filtro.competencia_inicial_custo_comparativo_antes}
				&competencia_final_antes=${state.filtro.competencia_final_custo_comparativo_antes}
				&competencia_inicial_depois=${state.filtro.competencia_inicial_custo_comparativo_depois}
				&competencia_final_depois=${state.filtro.competencia_final_custo_comparativo_depois}
				`
            );
            dispatch({
                type: "ANALISE_CUSTO_POR_UNIDADE_PERIODO_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaConsumoPorUnidadePeriodo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_CONSUMO_POR_UNIDADE_PERIODO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarConsumoPorUnidadePeriodo?id_usuario_logado=${usuarioLogado.id}
				&id_cliente=${idCliente}
				&competencia_inicial_antes=${state.filtro.competencia_inicial_consumo_comparativo_antes}
				&competencia_final_antes=${state.filtro.competencia_final_consumo_comparativo_antes}
				&competencia_inicial_depois=${state.filtro.competencia_inicial_consumo_comparativo_depois}
				&competencia_final_depois=${state.filtro.competencia_final_consumo_comparativo_depois}
				`
            );
            dispatch({
                type: "ANALISE_CONSUMO_POR_UNIDADE_PERIODO_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoCustoPorUnidadeMensal() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_UNIDADE_MENSAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const modoSafra = state.filtro.custo_ano_safra;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoPorUnidade?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&id_unidade_consumidora=${null}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}&ano=${
                    state.filtro.ano
                }&competencia_inicial=${state.filtro.competencia_inicial_custo}&competencia_final=${state.filtro.competencia_final_custo}&periodo_safra=${modoSafra}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_UNIDADE_MENSAL_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getListaGraficoCustoReativoPorUnidadeAcumuladoAno() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_UNIDADE_ACUMULADO_ANO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoReativoPorUnidadeAcumuladoAno?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente}&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}
			&competencia_inicial=${state.filtro.competencia_inicial_reativo}
			&competencia_final=${state.filtro.competencia_final_reativo}
            &periodo_safra=${false}&id_empresa=${idEmpresa}` //só usa true na aba Periodo Safra
            );
            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_REATIVO_UNIDADE_ACUMULADO_ANO_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export async function getListaCustoReativoPorUnidadePeriodo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;

            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_CONSUMO_REATIVO_POR_UNIDADE_PERIODO_LISTADO",
                payload: { data: [] },
            });

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarCustoReativoPorUnidadePeriodo?id_usuario_logado=${usuarioLogado.id}
				&id_cliente=${idCliente}
				&competencia_inicial_antes=${state.filtro.competencia_inicial_custo_reativo_comparativo_antes}
				&competencia_final_antes=${state.filtro.competencia_final_custo_reativo_comparativo_antes}
				&competencia_inicial_depois=${state.filtro.competencia_inicial_custo_reativo_comparativo_depois}
				&competencia_final_depois=${state.filtro.competencia_final_custo_reativo_comparativo_depois}
				`
            );

            // console.log(resp);
            dispatch({
                type: "ANALISE_CONSUMO_REATIVO_POR_UNIDADE_PERIODO_LISTADO",
                payload: resp,
            });
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function getGeracaoCadastro() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_CADASTRO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/geracao?id_usuario_logado=${usuarioLogado.id}&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(
                    idsUnidadesConsumidoras
                )}&listarUltimaCadastradaEmDiante=true`
            );

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_CADASTRO_LISTADO",
                payload: { data: resp.data || [] },
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoGeracaoEconomiaPonta() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_ECONOMIA_PONTA_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || null;
            const idsUnidadesConsumidoras = filtrarIdsUnidadesConsumidoras(state);
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoEconomiaPonta?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${idCliente}
			&ids_unidades_consumidoras=${encodeURIComponent(idsUnidadesConsumidoras)}`
            );

            dispatch({
                type: "ANALISE_GRAFICO_GERACAO_ECONOMIA_PONTA_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "ANALISE_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaGeradorasContratosAluguelHistorico() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || 0;
            const request = axios.get(`${consts.API_URL}/contrato-aluguel/listar-select-geradoras?id_cliente=${idCliente}&id_usuario_logado=${usuarioLogado.id}`);
            dispatch({
                type: "ANALISE_GERADORAS_CONTRATO_ALUGUEL_HISTORICO_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaContratosAluguelHistorico() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente || 0;
            const request = axios.get(`${consts.API_URL}/contrato-aluguel/listar-select?id_cliente=${idCliente}&id_usuario_logado=${usuarioLogado.id}`);
            dispatch({
                type: "ANALISE_CONTRATO_ALUGUEL_HISTORICO_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaDemandaContratoTipo() {
    const request = axios.get(`${consts.API_URL}/demandaContratoTipo/listarselect`);
    return {
        type: "ANALISE_CONTRATO_DEMANDA_TIPO_SELECT_LISTADO",
        payload: request,
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "ANALISE_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function buscaCusd(id, nomePdf) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(`${consts.API_URL}/demandaContrato/importarCusd?id=${id}`);
            if (resp.data && resp.data.arquivo_cusd) {
                dispatch(setArquivoPDF(resp.data.arquivo_cusd, nomePdf));
            }
        } catch (ex) {
            dispatch(setErroAPI(ex));
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function buscaCcer(id, nomePdf) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(`${consts.API_URL}/demandaContrato/importarCcer?id=${id}`);
            if (resp.data && resp.data.arquivo_ccer) {
                dispatch(setArquivoPDF(resp.data.arquivo_ccer, nomePdf));
            }
        } catch (ex) {
            dispatch(setErroAPI(ex));
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function getListaGraficoCustoTiposMultaAnual() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_TIPO_MULTA_ANUAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoTiposMulta?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente}
			&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_TIPO_MULTA_ANUAL_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoCustoMultaPorUnidadeAcumuladoAno() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_MULTA_UNIDADE_ACUMULADO_ANO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;

            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const modoSafra = state.filtro.multas_ano_safra;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoCustoMultaPorUnidade?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&ano=${state.filtro.ano_multas}&periodo_safra=${modoSafra}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "ANALISE_GRAFICO_CUSTO_MULTA_UNIDADE_ACUMULADO_ANO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaAnaliseCativoMercadoLivrePeriodo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch([
                {
                    type: "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_PERIODO",
                    payload: [],
                },
                {
                    type: "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_TIPO",
                    payload: [],
                },
                {
                    type: "ANALISE_TARIFAS_ANEEL_PERIODO",
                    payload: [],
                },
            ]);

            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            if (ids_unidades_consumidoras.length !== 1) return {};

            //busca quantidades de energia e demanda para simular custo no cativo
            const [respostaSimulacaoCativo, respostaGraficoBarras, respostaGraficoPizza] = await Promise.all([
                axios.get(
                    `${consts.API_URL}/fatura/listarAnaliseCativoMercadoLivre?id_usuario_logado=${
                        usuarioLogado.id
                    }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&competencia_inicial=${
                        state.filtro.competencia_inicial_mercado_livre
                    }&competencia_final=${state.filtro.competencia_final_mercado_livre}`
                ),
                //busca lista custo por periodo
                axios.get(
                    `${consts.API_URL}/fatura/listarGraficoCustoMercadoLivrePeriodo?id_usuario_logado=${
                        usuarioLogado.id
                    }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&competencia_inicial=${
                        state.filtro.competencia_inicial_mercado_livre
                    }&competencia_final=${state.filtro.competencia_final_mercado_livre}`
                ),
                //busca lista pro pizza
                axios.get(
                    `${consts.API_URL}/fatura/listarGraficoCustoMercadoLivreTipo?id_usuario_logado=${
                        usuarioLogado.id
                    }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&competencia_inicial=${
                        state.filtro.competencia_inicial_mercado_livre
                    }&competencia_final=${state.filtro.competencia_final_mercado_livre}`
                ),
            ]);

            const erros = [];
            if (respostaSimulacaoCativo.data.erros) erros.push(...respostaSimulacaoCativo.data.erros);
            const listaSimulacaoCativo = respostaSimulacaoCativo.data.dados || [];

            //só tem um item, com o acumulado do periodo filtrado
            const dadosGraficoBarras = (respostaGraficoBarras.data || []).map((item) => {
                const acumuladoPeriodoCativo = listaSimulacaoCativo.reduce((acc, atual) => (acc += parseFloat(atual.resultado_total_cativo) || 0), 0);

                const economia = acumuladoPeriodoCativo - item.valor_mercado_livre >= 0 ? acumuladoPeriodoCativo - item.valor_mercado_livre : 0;
                return {
                    ...item,
                    valor_cativo: acumuladoPeriodoCativo,
                    valor_economia: economia,
                    valor_economia_percentual: ` (${adicionarPontosMilhar(acumuladoPeriodoCativo > 0 ? (economia / acumuladoPeriodoCativo) * 100 : 0)}%)`,
                };
            });

            const dadosGraficoPizza = respostaGraficoPizza.data || [];

            // console.log({ acumuladoPeriodo, dadosGraficoPizza, dadosGraficoBarras });
            //altera os dados para pegar o simulado do cativo como valor do custo no cativo, e ajusta o calculo de economia com base nesse valor
            dispatch([
                {
                    type: "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_TIPO",
                    payload: dadosGraficoPizza,
                },
                {
                    type: "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_PERIODO",
                    payload: dadosGraficoBarras,
                },
                {
                    type: "ANALISE_TARIFAS_ANEEL_PERIODO",
                    payload: listaSimulacaoCativo,
                },
            ]);
            // console.log("getListaAnaliseCativoMercadoLivrePeriodo");
            // console.table(erros);
            erros.map((erro) => setError(erro));
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function atualizarListasAnaliseCativoMercadoLivrePeriodo({ dadosGraficoBarrasPeriodo, dadosGraficoBarrasMensal }) {
    return async (dispatch, getState) => {
        dispatch([
            {
                type: "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_PERIODO",
                payload: dadosGraficoBarrasPeriodo,
            },
            {
                type: "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_MENSAL",
                payload: dadosGraficoBarrasMensal,
            },
        ]);
    };
}

export function getListaGraficoComparativoComSemSolarMensal() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            
            dispatch({
                type: "ANALISE_GERACAO_GRAFICO_COMPARATIVO_COM_SEM_SOLAR_MENSAL_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;

            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listaGraficoComparativoComSemSolarMensal?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&ano=${state.filtro.ano_comparativo_com_sem_solar}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "ANALISE_GERACAO_GRAFICO_COMPARATIVO_COM_SEM_SOLAR_MENSAL_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        } 
    };
}

export function getListaGraficoComparativoComSemSolarPeriodo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "ANALISE_GERACAO_GRAFICO_COMPARATIVO_COM_SEM_SOLAR_PERIODO_LISTADO",
                payload: { data: [] },
            });

            const state = getState().analise;

            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listaGraficoComparativoComSemSolarPeriodo?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&competencia_inicial=${
                    state.filtro.competencia_inicial_geracao_comparativo_com_sem_solar
                }&competencia_final=${state.filtro.competencia_final_geracao_comparativo_com_sem_solar}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "ANALISE_GERACAO_GRAFICO_COMPARATIVO_COM_SEM_SOLAR_PERIODO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        } 
    };
}

export async function getListaAnaliseCativoMercadoLivreMensal() {
    return async (dispatch, getState) => {
        try {
            const arrayZerado = Array.from({ length: 12 }, () => ({}));
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch([
                {
                    type: "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_MENSAL",
                    payload: arrayZerado,
                },
                {
                    type: "ANALISE_TARIFAS_ANEEL_MENSAL",
                    payload: [],
                },
            ]);
            const state = getState().analise;
            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const ids_unidades_consumidoras = filtrarIdsUnidadesConsumidoras(state);
            if (ids_unidades_consumidoras.length !== 1) return {};

            const [respostaSimulacaoCativoMensal, respostaListaGraficoMensal] = await Promise.all([
                axios.get(
                    `${consts.API_URL}/fatura/listarAnaliseCativoMercadoLivre?id_usuario_logado=${
                        usuarioLogado.id
                    }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&ano=${state.filtro.ano_mercado_livre}`
                ),
                axios.get(
                    `${consts.API_URL}/fatura/listarGraficoCustoMercadoLivreMensal?id_usuario_logado=${
                        usuarioLogado.id
                    }&id_cliente=${idCliente}&ids_unidades_consumidoras=${encodeURIComponent(ids_unidades_consumidoras)}&ano=${state.filtro.ano_mercado_livre}`
                ),
            ]);

            const erros = [];
            if (respostaSimulacaoCativoMensal.data.erros) erros.push(...respostaSimulacaoCativoMensal.data.erros);
            const listaSimulacaoCativoMensal = respostaSimulacaoCativoMensal.data.dados || [];

            const dadosGraficoBarrasMensal = (respostaListaGraficoMensal.data || arrayZerado).map((item) => {
                if (parseFloat(item.valor_fatura)) {
                    return {
                        ...item,
                        valor_cativo: parseFloat(item.valor_fatura),
                        valor_cativo_bullet: `Cliente\n ainda no\n mercado\n cativo`,
                    };
                } else {
                    const simulacao = listaSimulacaoCativoMensal.find((el) => el.competencia == item.competencia) || {};
                    const economia = simulacao.resultado_total_cativo - item.valor_mercado_livre >= 0 ? simulacao.resultado_total_cativo - item.valor_mercado_livre : 0;
                    const tooltip = {
                        bandeira_verde: ["Bandeira Verde: ", "#00ba60"],
                        bandeira_amarela: ["Bandeira Amarela: ", "#ffe512"],
                        bandeira_vermelha_p1: ["Bandeira Vermelha P1: ", "#ff1d1f"],
                        bandeira_vermelha_p2: ["Bandeira Vermelha P2: ", "#c8060a"],
                    };
                    return {
                        ...item,
                        icone: simulacao.icone ? bandeiras[simulacao.icone] : null,
                        color: simulacao.icone ? tooltip[simulacao.icone][1] : null,
                        icone_tooltip: simulacao.icone ? tooltip[simulacao.icone][0] + "R$ " + adicionarPontosMilhar(simulacao.tarifa_bandeira, 6) + " por kWh" : null,
                        valor_cativo: simulacao.resultado_total_cativo,
                        valor_imposto_cativo: simulacao.resultado_total_cativo - simulacao.resultado_total_cativo / simulacao.fator_multiplicacao_imposto,
                        valor_economia: economia,
                        valor_economia_percentual: ` (${adicionarPontosMilhar(simulacao.resultado_total_cativo > 0 ? (economia / simulacao.resultado_total_cativo) * 100 : 0)}%)`,
                    };
                }
            });

            dispatch([
                {
                    type: "ANALISE_GRAFICO_CUSTO_MERCADO_LIVRE_MENSAL",
                    payload: dadosGraficoBarrasMensal,
                },
                {
                    type: "ANALISE_TARIFAS_ANEEL_MENSAL",
                    payload: listaSimulacaoCativoMensal,
                },
            ]);
            // console.log("getListaAnaliseCativoMercadoLivreMensal");
            // console.table(erros);
            erros.map((erro) => setError(erro));
        } catch (error) {
            setErroAPI(error);
        }
    };
}
